import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";

import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import EntityPage from "./pages/EntityPage";
import Nominees from "./pages/Nominees";
import EmergencyPlan from "./pages/EmergencyPlan";
import EmergencyAccess from "./pages/EmergencyAccess";
import Vault from "./pages/Vault";
import YearlyReview from "./pages/YearlyReview";
import ShareLinks from "./pages/ShareLinks";
import SharedVault from "./pages/SharedVault";
import ImportPage from "./pages/Import";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";

function Shell() {
  const [counts, setCounts] = useState({});
  return (
    <Layout counts={counts}>
      <Routes>
        <Route path="/" element={<Dashboard onData={setCounts} />} />
        <Route path="/m/:module" element={<EntityPage />} />
        <Route path="/nominees" element={<Nominees />} />
        <Route path="/emergency-plan" element={<EmergencyPlan />} />
        <Route path="/emergency-access" element={<EmergencyAccess />} />
        <Route path="/vault" element={<Vault />} />
        <Route path="/review" element={<YearlyReview />} />
        <Route path="/shares" element={<ShareLinks />} />
        <Route path="/import" element={<ImportPage />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/settings" element={<Settings />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster richColors position="top-right" />
          <Routes>
            {/* Public share viewer — no auth */}
            <Route path="/share/:token" element={<SharedVault />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <Shell />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
